import useSWR from 'swr'

export default function useCustomerKits(id: string) {
  const { data, error, mutate } = useSWR(`/api/account/kits/${id}`)

  return {
    kit: data?.kit || undefined,
    isLoading: !error && !data,
    isError: error,
    mutate
  }
}

export async function activationCode(id: string) {

  return fetch(`/api/activation_code/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export async function useCustomerKitResultAndCheck(id: string, payload: any) {
  return await fetch(`/api/account/kits/${id}/resultAccessCheck`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
}

export async function useEmailCheck(payload: any) {
  return await fetch(`/api/auth/emailCheck`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
}

export async function useGenerateDeclarationOfParticipation(payload: any) {
  return await fetch(`/api/declarationOfParticipation`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
}

export async function useAddRemiOrder(payload: any) {
  return await fetch(`/api/createRemiOrder`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
}

export async function useCustomerKitActivationCheck(id: string, payload: any) {
  return await fetch(`/api/account/kits/${id}/activationAccessCheck`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
}

export async function useCustomerKitFindByEmailAndOrderWL(payload: any) {
  return await fetch(`/api/account/kits/findByEmailAndOrderWL`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
}

export async function useCustomerKitFindByQueryWL(payload: any) {
  return await fetch(`/api/account/kits/findWL`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
}

export function useCustomerKitResult(id: string) {
  const { data, error, mutate } = useSWR(id ? `/api/account/kits/${id}/status` : null)

  return {
    result: data?.result || undefined,
    kit: data?.kit || undefined,
    consultation: data?.consultation || undefined,
    isLoading: !error && !data,
    isError: error,
    mutate
  }
}

export function useCustomerKitReport(id: string) {
  const { data, error } = useSWR(id ? `/api/account/kits/${id}/download` : null)

  return {
    result: data?.result || undefined,
    kit: data?.kit || undefined,
    isLoading: !error && !data,
    isError: error
  }
}

export async function useCustomerOrderKitsResult(payload = []) {

  return await fetch(`/api/account/kits/bulk-status`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
}

export function activateKitWithID(id: any, payload: any) {
  return fetch(`/api/account/kits/${id}/activate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
}

/** Late booking of the return QR for an activated WL kit without one. */
export function createReturnQrWL(id: any) {
  return fetch(`/api/account/kits/${id}/create-return-qr`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function resendReturnQrWL(id: any) {
  return fetch(`/api/account/kits/${id}/resend-return-qr`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function shareKitWithID(id: any, payload: any) {
  return fetch(`/api/account/kits/${id}/share`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
}

export function autoActivateList(id: any, payload: any) {
  return fetch(`/api/autoActivateList`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
}

export function bookOrEditConsultation(id: any, payload: any) {
  return fetch(`/api/account/kits/${id}/consultation`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
}

export function bookOrEditConsultationWl(id: any, payload: any) {
  return fetch(`/api/account/kits/${id}/consultationWl`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
}

export function cancelConsultation(id: any) {
  return fetch(`/api/account/kits/${id}/consultation/cancel`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: undefined
  })
}

export function cancelConsultationWl(id: any) {
  return fetch(`/api/account/kits/${id}/consultation/cancelWl`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: undefined
  })
}
